import localexpert from './lx';
import traveler from './traveler';

export default {
  localexpert,
  traveler,
};
